import React, { useRef, useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";
import { Spin, Select, Input, message, Modal, Button, Form, DatePicker } from "antd";
import { SearchOutlined, LoginOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DoubleleftSvg from '@/img/doubleleft.svg';
import { useSelector } from "react-redux";
import OpenData from '@/components/open-data/open-data';
import apiConversation from "@/apis/pc/conversation/conversation";
import { debounceFunc, getWxMessageType, browser, throttle } from "@/utils/utils";
import calendarIcon from "@/img/calendar-icon.png"
import _ from 'lodash';
import moment from "moment";
const { Option } = Select;
const { Search } = Input;
const ConversationFilter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 24px;
  padding: 16px 0;
  .conversation-filter-search {
    display: flex;
    align-items: center;
    .date-span{
      margin-left: 3px;
      flex: none;
    }
      
    .ant-input-affix-wrapper{
      border-radius: 4px;
      border: 1px solid #E8EBF6;
    }
    .ant-input-affix-wrapper-focused{
      border: 1px solid var(--ant-primary-color);
    }
    .ant-input&::placeholder {
      color: #9A9EBA;
    }
    .ant-input-suffix{
      color: #9A9EBA;
    }
    .conversation-filter-search-date {
      width: 32px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E8EBF6;
      margin-left: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex: none;
      .search-date-icon{
        width: 14px;
        height: 14px;
        flex: none;
      }
      .ant-picker-range-separator {
        display: none
      }
      .ant-picker-input {
        input {
          display: none;
        }
        .ant-picker-clear{
          display: none;
        }
        .ant-picker-suffix{
          margin-left: 7px;
        }
      }
      .ant-picker.ant-picker-borderless {
        padding: 0;
        width: 100%;
        height: 100%;
      }
      .ant-picker.ant-picker-range{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .ant-picker-suffix{
          margin-left: 0;
        }
        
      }
    }
  }
  .conversation-filter-label {
    display: flex;
    align-items: center;
    .conversation-filter-label-item {
      line-height: 22px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E8EBF6;
      font-weight: 400;
      font-size: 12px;
      color: #767B9E;
      padding: 0 8px;
      margin-right: 8px;
      cursor: pointer;
      flex: none;
      &:last-child{
        margin-right: 0px;
      }
    }
    .conversation-filter-label-item-active {
      color: #FFFFFF;
      background: #FC8352;
      line-height: 24px;
      border: 0px solid #E8EBF6;
    }
  }
`;

const msgTablist = [
  { title: '全部', key: '1' },
  { title: '文件', key: '2' },
  { title: '图片/视频', key: '3' },
  // { title: '链接', key: '4' },
];
const covSearchMessageFilter = forwardRef((props, ref) => {
  
  useImperativeHandle(ref, () => ({
  }));
  const { onChange, chatType, searchTime, searchContent } = props;
  const [timeInterval, setTimeInterval] = useState(undefined) // 消息时间选择不可选

  const handleTimeChange = (values) => {
    onChange && onChange({searchTime: values})
  }
  const disabledDateFn = (current) => {
    return current && (current > moment().endOf('day'));
    // return timeInterval ? 
    //   parseInt(moment(moment(current).format('YYYY-MM-DD')).format('x')) < parseInt(moment(moment(timeInterval).subtract(29, 'd').format('YYYY-MM-DD')).format('x')) || 
    //   parseInt(moment(moment(current).format('YYYY-MM-DD')).format('x')) > parseInt(moment(moment(timeInterval).add(29, 'd').format('YYYY-MM-DD')).format('x')) || 
    //   current && (current > moment().endOf('day'))
    //   : 
    //   current && (current > moment().endOf('day'));
  }
  const calendarChange = (value) => {
    if (value && value[0]) {
      setTimeInterval(value[0]);
    }
  }
  return (
    <ConversationFilter>
      <div className="conversation-filter-search">
        <Input
          placeholder="请输入搜索内容"
          value={searchContent}
          style={{width: 160}}
          suffix={
            <SearchOutlined
                style={{
                  color: '#9A9EBA',
                }}
              />
          }
          onChange={(e) => {
            onChange && onChange({searchContent: e.target.value.trim()})
          }}
        />

        <div className="conversation-filter-search-date">
          <DatePicker
            onChange={handleTimeChange}
            disabledDate={disabledDateFn}
            // onCalendarChange={calendarChange}
            // onOpenChange={e => !e ? setTimeInterval(null) : searchTime ? setTimeInterval(searchTime[0]) : ''}
            inputReadOnly='true'
            value={searchTime}
            bordered={false}
            suffixIcon={
              <img className="search-date-icon" src={calendarIcon} />
            }
          />
        </div>
        <span className="date-span">
          {searchTime ? moment(searchTime).format('YYYY-MM-DD') : ''}
          {searchTime ? <CloseCircleOutlined style={{marginLeft: 4}} onClick={() => {onChange && onChange({searchTime: ''})}} /> : ''}
        </span>
      </div>
      <div className="conversation-filter-label">
        {
          msgTablist?.map(item => {
            return (
              <div
                className={`conversation-filter-label-item ${item.key == chatType ? 'conversation-filter-label-item-active' : ''}`}
                onClick={() => onChange && onChange({chatType: item.key})}
              >{item.title}</div>
            );
          })
        }
      </div>
    </ConversationFilter>
  );
});

export default covSearchMessageFilter;